import ReactDOM from 'react-dom';
import React from 'react';

export const readFile = (file, readAs = ReadAsTypes.ArrayBuffer) => {
    if (!file) {
        return Promise.reject('Nenhum arquivo especificado');
    }
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        if (readAs === ReadAsTypes.DataURL) {
            reader.readAsDataURL(file);
        } else {
            reader.readAsArrayBuffer(file);
        }
    });
};

export class SelectFile extends React.Component {

    handleFile = ({ target }) => {
        this.props.onChange(target.files[0]);
        ReactDOM.findDOMNode(this.upload).value = '';
    };

    render() {
        const { children, style, accept = FileTypes.Image, text = 'Escolher arquivo', disabled = false } = this.props;
        const acceptString = Array.isArray(accept) ? accept.toString() : accept;

        return (
            <React.Fragment >
                <input
                    id='myInput'
                    type='file' accept={acceptString}
                    ref={(ref) => this.upload = ref}
                    style={{ display: 'none' }}
                    onChange={this.handleFile}/>
                {children
                    ? <div style={ style } onClick={() => !disabled && this.upload.click()}>{children}</div>
                    : <button onClick={() => !disabled && this.upload.click()}>{text}</button>
                }
            </React.Fragment>
        );
    }
}

export default class FileUploader extends React.Component {

    handleFile = async (file) => {
        const { readAs = ReadAsTypes.DataURL, handleFileChange } = this.props;
        const result = await readFile(file, readAs);
        handleFileChange(result);
    };

    render() {
        return <SelectFile {...this.props} onChange={this.handleFile}/>;
    }
}

export const ReadAsTypes = {
    ArrayBuffer: 'ArrayBuffer',
    DataURL: 'DataURL',
};

export const FileTypes = {
    Image: 'image/*',
    PdfFile: 'application/pdf',
    DocxFile: '.docx',
};



// WEBPACK FOOTER //
// ./src/components/file-uploader/file-uploader.js